import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

interface DuplicateContactTemplateInput {
  uuid: string;
  name: string;
}

export const duplicateContactTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/contact_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

export function useDuplicateContactTemplate(onSuccessCallback: (uuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateContactTemplateInput) => duplicateContactTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allContactTemplates],
      });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the contact template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
